
import { defineComponent } from "vue";
import StreetView from "./StreetView.vue";
export default defineComponent({
  components: { StreetView },
});
